export default {
  product: {
    monthlySubscription: {
      en: 'Monthly subscription',
    },
    thirdMonthFree: {
      en: '3 month of fragrance',
    },
  },

  productsPerMonth: {
    en: '{count, plural, one {# product} other {# products}}/month',
  },

  shipping: {
    en: 'Shipping',
  },

  tax: {
    en: 'Tax',
  },

  discount: {
    common: {
      en: 'Discount',
    },
    subscription: {
      en: 'Subscription discount',
    },
    secondMonthFree: {
      en: '2nd Month\'s {gender, select, female {Perfume} male {Cologne}}',
    },
    thirdMonthFree: {
      en: 'Subscription 1st month free',
    },
  },

  offerNote: {
    en: 'Offer applied to the first month only',
  },

  caseSubscription: {
    en: 'Case subscription',
  },

  free: {
    en: 'Free',
  },

  upcharge: {
    label: {
      en: 'Premium upcharge',
    },
    note: {
      en: 'Full-size product',
    },
  },
}
